import type { EscrowKpis } from '../../types';

const fmtMoney = (v: number) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', notation: 'compact', maximumFractionDigits: 1 }).format(v || 0);

/**
 * The escrow list's four KPI cards in the design's language (OO5): a white 6px card on a
 * hairline, the uppercase letter-spaced eyebrow, the number in Oswald. Overdue is the one
 * number that turns KW red, and only when it is above zero - the design reserves red for
 * actions and overdue states.
 */
export default function KpiStrip({ kpis }: { kpis: EscrowKpis }) {
  const cards = [
    { label: 'Overdue', value: String(kpis.overdue), red: kpis.overdue > 0 },
    { label: 'Due this week', value: String(kpis.due_this_week), red: false },
    { label: 'Closings this month', value: String(kpis.closings_this_month), red: false },
    { label: 'Value in flight', value: fmtMoney(kpis.value_in_flight), red: false },
  ];
  return (
    <div className="mb-4 grid grid-cols-2 gap-4 md:grid-cols-4">
      {cards.map((c) => (
        <div key={c.label} className="rounded-xl border border-gray-200 bg-white px-[18px] py-4">
          <p className="text-[9.5px] font-bold uppercase tracking-[.13em] text-gray-400">{c.label}</p>
          <p className={`mt-2 font-display text-[26px] font-semibold leading-none tabular-nums ${c.red ? 'text-primary-500' : 'text-gray-900'}`}>{c.value}</p>
        </div>
      ))}
    </div>
  );
}
